<div class="info-box mb-4 bg-white">
  <a [routerLink]="'auction/' + data.uuid" class="text-decoration-none">
    <div class="position-relative info-box__head f-color-dark">
      <div class="info-box__head__gradient position-absolute"></div>
      <!-- <img [src]="data.image ? data.image.url + '_thumbnail.jpg' : ''"
        class="info-box__head__img rounded" alt="img" /> -->
      <picture>
        <source
          type="image/webp"
          [srcset]="
            data.image
              ? data.image.url + '_thumbnail.webp'
              : '/assets/images/no-img/no-image_thumb.webp'
          "
        />
        <source
          type="image/jpg"
          [srcset]="
            data.image
              ? data.image.url + '_thumbnail.jpg'
              : '/assets/images/no-img/no-image_thumb.jpg'
          "
        />
        <img
          [src]="
            data.image
              ? data.image.url + '.jpg'
              : '/assets/images/no-img/no-image.jpg'
          "
          alt="img"
          class="info-box__head__img rounded position-absolute"
        />
      </picture>
      <div
        class="position-absolute info-box__head__status d-flex justify-content-center align-items-center p-1 text-center"
        *ngIf="
          data.status_key === 'not_started' || data.status_key === 'active'
        "
      >
        <span class="f-regular f-size-11 pl-2 pr-2 f-color-white">{{
          data.status
        }}</span>
        <!-- <app-countdown [startDate]="data.start_date_timestamp" [endDate]="data.end_date_timestamp" [auctionStatus]="{name: data.status, key: data.status_key}"></app-countdown> -->
      </div>
    </div>
    <div
      class="info-box__content p-relative d-flex flex-column justify-content-center f-color-dark"
    >
      <div class="info-box__container-wrapper">
        <div class="info-box__content__header d-flex justify-content-between">
          <div class="d-flex flex-column">
            <span class="f-size-20 f-color-dark fw-bold line-height-1"
              >{{ data.current_price | priceFormatter }} <span>₾</span></span
            >
            <span class="f-size-13 mt-1 f-color-slate">{{ priceType }}</span>
          </div>
          <div class="d-flex flex-column">
            <span
              class="f-size-20 f-color-dark fw-bold text-right line-height-1"
              >{{ data.warranty_price | priceFormatter }} <span>₾</span></span
            >
            <span class="f-size-13 mt-1 f-regular f-color-slate text-right"
              >საგარანტიო</span
            >
          </div>
        </div>
        <p
          class="info-box__content__title f-color-dark fw-medium f-size-13"
          data-toggle="tooltip"
          data-placement="top"
          [title]="data.title"
        >
          {{ data.title }}
        </p>
        <p
          class="info-box__content__street f-color-slate-40 f-size-14 line-height-1"
          data-toggle="tooltip"
          data-placement="top"
          [title]="data.street"
        >
          {{ data.street }}
        </p>
      </div>
      <div class="position-relative">
        <div
          [ngClass]="{ 'd-flex': data.status_key !== 'active' }"
          [ngStyle]="{
            'margin-bottom': data.status_key !== 'active' ? '1px' : 'none'
          }"
          class="info-box__content__price info-box__container-wrapper f-size-13 justify-content-between align-items-center pb-2 pt-2"
        >
          <div class="info-box__content__timer">
            <img src="/assets/images/clock.svg" alt="clock" />
            <app-countdown
              [startDate]="data.start_date_timestamp"
              [endDate]="data.end_date_timestamp"
              [auctionStatus]="{ name: data.status, key: data.status_key }"
            ></app-countdown>
          </div>
          <span
            *ngIf="data.status_key !== 'not_started'"
            class="f-color-vibrant-blue f-size-13"
            >{{ data.bids_count }} ბიდი</span
          >
        </div>
        <div
          *ngIf="data.status_key === 'active'"
          class="info-box__content__bid info-box__container-wrapper justify-content-center align-items-center"
        >
          <button
            class="btn btn-primary rounded-pill w-100 font-weight-bold f-size-13"
          >
            ბიდის გაკეთება
          </button>
        </div>
        <div
          class="info-box__content__footer info-box__container-wrapper d-flex d-md-none justify-content-between align-items-center"
        >
          <span
            class="f-size-13 f-color-slate-40 mr-1"
            data-toggle="tooltip"
            data-placement="top"
            [title]="data.auction_number"
            >აუქციონი # {{ data.auction_number }}</span
          >
          <span
            class="f-size-13 f-color-slate-40"
            data-toggle="tooltip"
            data-placement="top"
            [title]="data.lot_number"
            >ლოტი # {{ data.lot_number }}</span
          >
        </div>
      </div>
    </div>
  </a>
</div>
